<script setup lang="ts">
import UiGlow from './UiGlow.vue';

/**
 * The shell of a full screen, as v1 drew it: the canvas with the purple glow
 * in the top corner, clear of notches on the sides. It draws no header and no
 * content padding: `UiAppPage` puts `UiAppHeader` and the gutter in it, and a
 * screen with its own top (the sign-in flow, the reader) builds on it directly
 * — the `header` slot for its bar, the default slot for the rest.
 */
defineSlots<{
  default?: () => unknown;
  header?: () => unknown;
}>();
</script>

<template>
  <div class="relative isolate flex min-h-dvh flex-col overflow-x-clip bg-canvas pr-safe-right pl-safe-left">
    <UiGlow />
    <slot name="header" />
    <slot />
  </div>
</template>
